export enum AccessMode {
    Deny = 0,
    ReadOnly = 1,
}
